"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const types = require("@prismicio/types");
const documentToLinkField = require("./documentToLinkField.cjs");
const asLink = (linkFieldOrDocument, linkResolver) => {
  if (!linkFieldOrDocument) {
    return null;
  }
  const linkField = "link_type" in linkFieldOrDocument ? linkFieldOrDocument : documentToLinkField.documentToLinkField(linkFieldOrDocument);
  switch (linkField.link_type) {
    case types.LinkType.Media:
    case types.LinkType.Web:
      return "url" in linkField ? linkField.url : null;
    case types.LinkType.Document: {
      if ("id" in linkField && linkResolver) {
        const resolvedURL = linkResolver(linkField);
        if (resolvedURL != null) {
          return resolvedURL;
        }
      }
      if ("url" in linkField && linkField.url) {
        return linkField.url;
      }
      return null;
    }
    case types.LinkType.Any:
    default:
      return null;
  }
};
exports.asLink = asLink;
//# sourceMappingURL=asLink.cjs.map
